import React from 'react'
import Questions from '../../Components/masterEntry/Questions';

const QuestionsPage = () => {
  return (
    <>
      <Questions />
    </>
  )
}

export default QuestionsPage;
